import { motion } from "framer-motion";
import ScrollReveal from "./scroll-reveal";

export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <ScrollReveal>
            <div>
              <h2 className="text-4xl md:text-5xl font-playfair font-bold mb-6">
                Crafting Excellence Since Day One
              </h2>
              <p className="text-lg text-neutral mb-6 leading-relaxed">
                At KASA Furniture, we believe that exceptional office furniture is more than just functional pieces – 
                it's about creating environments that inspire productivity, foster creativity, and reflect the professional 
                standards of modern businesses.
              </p>
              <p className="text-lg text-neutral mb-8 leading-relaxed">
                Our commitment to quality craftsmanship, innovative design, and sustainable practices has made us 
                the preferred choice for businesses seeking premium office solutions.
              </p>
              <div className="grid grid-cols-2 gap-6">
                <motion.div
                  className="glass-effect rounded-xl p-6 text-center hover-lift hover-cursor"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  <h3 className="text-2xl font-bold text-accent mb-2">500+</h3>
                  <p className="text-neutral">Happy Clients</p>
                </motion.div>
                <motion.div
                  className="glass-effect rounded-xl p-6 text-center hover-lift hover-cursor"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  <h3 className="text-2xl font-bold text-accent mb-2">15+</h3>
                  <p className="text-neutral">Years Experience</p>
                </motion.div>
              </div>
            </div>
          </ScrollReveal>
          
          <ScrollReveal delay={0.3}>
            <motion.div
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.3 }}
            >
              <img
                src="https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600"
                alt="KASA Furniture Showroom"
                className="rounded-2xl shadow-2xl w-full hover-cursor"
              />
            </motion.div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
